import PixelModal from "@/components/product/pixel/PixelModal.vue";
import { mapState } from "vuex";
export default {
  components: { PixelModal },
  data() {
    return {
      modal: false,
      loading: false,
      search_text: "",
      editedPixelIndex: null,
      editedPixel: null,
      pixelType: "facebook",
      columns: ["Ferramenta", "Pixel", "Label de conversão", ""],
      actions: [
        {
          text: "Editar",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false
          },
          event: "edit-pixel"
        },
        {
          text: "Remover",
          class: "text-danger",
          icon: "fa-regular fa-trash-can",
          confirmation: {
            newDesign: true,
            submitButtonClass: "btn-danger",
            enable: true,
            text:
              "Deseja mesmo excluir este pixel? Após a exclusão as páginas de checkout não enviarão mais dados para as plataformas"
          },
          event: "remove-pixel"
        }
      ]
    };
  },
  computed: {
    ...mapState("product", ["product"])
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$store
        .dispatch("product/getProduct", this.product.id)
        .then()
        .finally(() => {
          this.loading = false;
        });
    },
    search(text) {
      this.search_text = text;
    },
    newPixel(type) {
      this.pixelType = type;
      this.modal = true;
    },
    editPixel(pixel, index) {
      this.editedPixelIndex = index;
      this.pixelType = pixel.type;
      this.editedPixel = pixel;
      this.modal = true;
    },
    updatePixel(pixel, success_msg, error_msg) {
      this.$store
        .dispatch("product/put", {
          id: this.product.id,
          pixel
        })
        .then(() => {
          this.$message.success(success_msg);
          this.modal = false;
          this.refresh();
        })
        .catch(error => {
          if (error.response && error.response.detail) {
            this.$message.error(error.response.detail);
          } else {
            this.$message.error(error_msg);
          }
        });
    },
    submitRemovePixel(removed_index) {
      // use index to remove because the procuders can use two pixels with the same code
      this.updatePixel(
        this.product.pixel.filter((_, index) => index !== removed_index),
        "O pixel foi deletado",
        "Não foi possível deletar o pixel"
      );
    },
    submitEditPixel(pixel) {
      const pixelList = this.product.pixel.map((p, index) =>
        index == this.editedPixelIndex ? pixel : p
      );

      this.updatePixel(
        pixelList,
        "O novo pixel foi atualizado",
        "Não foi possível atualizar as informações pixel"
      );
    },
    submitPixel(pixel) {
      this.updatePixel(
        [...this.product.pixel, pixel],
        "O novo pixel foi adicionado",
        "Não foi possível salvar o novo pixel"
      );
    }
  },
  watch: {
    modal(v) {
      if (!v) {
        this.editedPixelIndex = null;
        this.editedPixel = null;
      }
    }
  }
};
